/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CreatePortfolioTemplatePageService";
const log: any = LoggerModule.getInstance();

export class CreatePortfolioTemplatePageService {
  private static instance: CreatePortfolioTemplatePageService;
  private vapp: VApplication;
  private credentialList: any = [];
  private userGroupList: any = [];
  private createPortfolioTemplate: any = {};

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): CreatePortfolioTemplatePageService {
    if (!CreatePortfolioTemplatePageService.instance) {
      CreatePortfolioTemplatePageService.instance =
        new CreatePortfolioTemplatePageService(props);
    }
    return CreatePortfolioTemplatePageService.instance;
  }

  public async getPageContent(args:any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    // //Kanban Props
    // compProps = await agent.getKanbanProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    //   this.kanbanList = compProps.kanbanList;
    // }

    // //Evidence Kanban Props
    // compProps = await agent.getEvidenceKanbanProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    //   this.evidenceKanbanList = compProps.evidenceKanbanList;
    // }

    //get credential template props 
    compProps = await agent.getAppCardListProps(args);
    if (compProps) {
      content = { ...content, ...compProps};
    }    

    //get user groups props 
    compProps = await agent.getUserGroupListProps(args);
    if (compProps) {
      content = { ...content, ...compProps};
    }

    //CreateTemplate Props
    compProps = await agent.getCreateTemplateProps({});
    if (compProps) {
      content = { ...content, ...compProps, ...this.createPortfolioTemplate };
    }

    return content;
  }

  public updateCredentialList(list: any[]) {
    this.credentialList = list ?? [];
  }

  public updateUserGroupList(list: any[]) {
    this.userGroupList = list ?? [];
  }

  public updateTemplateMeta(template: {
    templateName: string;
    templateDescription: string;
    templateLogo: any;
    templateBanner:any;
  }) {
    this.createPortfolioTemplate = template ?? {};
  }

  public getTemplateMeta() {
    return this.createPortfolioTemplate;
  }

  public getCredentialList() {
    return {
      credentialList: this.credentialList,
    };
  }

  public getUserGroupList() {
    return {
      userGroupList: this.userGroupList,
    };
  }

  public resetStepperData() {
    this.createPortfolioTemplate = [];
    this.userGroupList = [];
    this.credentialList = [];
  }

  public previewCredentialTemplate() {
    const agent = getAgent();
    return agent.getPreviewTemplateSync({
      credentialMeta: this.createPortfolioTemplate,
      credentialList: this.credentialList,
      userGroupList: this.userGroupList,
    });
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public submitTemplate(args: any) {
    const agent = getAgent();
    return agent.getSubmitTemplate(args);
  }

  public getDefaultSelectedCred(){
   let _credentials:any = [];
   if(Array.isArray(this.credentialList) && this.credentialList.length > 0){
    this.credentialList?.forEach(element => {
      _credentials.push(element?.appCardId)
    });
   }
    console.log('app card id selected:', _credentials);
    return _credentials;
  }

  public getDefaultSelectedUser(){
    let _users:any = [];
   if(Array.isArray(this.userGroupList) && this.userGroupList.length > 0){
    this.userGroupList?.forEach(element => {
      _users.push(element?.appCardId)
    });
   }
    console.log('app card id selected:', _users);
    return _users;
  }
}
